import { render, staticRenderFns } from "./JuniorRallyScores.vue?vue&type=template&id=281c2e61"
import script from "./JuniorRallyScores.vue?vue&type=script&lang=ts"
export * from "./JuniorRallyScores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports